module.exports = __webpack_public_path__ + "img/logo-izidok-white.daa3bf50.png";